var _defs, _rect, _rect2, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 3,
    width: 20,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 3,
    width: 20,
    height: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,1H1L0,2V8L1,9H23l1-1V2ZM22,7H2V3H22Zm-1,4h2V22l-1,1H2L1,22V11H3V21H21Zm-5,1v2H8V12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/1772534745/media/icon-archive.576b37264f0e10d2b72d45de5f132fc5.svg";
export { ForwardRef as ReactComponent };